import { render, staticRenderFns } from "./SecurityInfoCard.vue?vue&type=template&id=2019cc24&scoped=true"
import script from "./SecurityInfoCard.vue?vue&type=script&lang=js"
export * from "./SecurityInfoCard.vue?vue&type=script&lang=js"
import style0 from "./SecurityInfoCard.vue?vue&type=style&index=0&id=2019cc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2019cc24",
  null
  
)

export default component.exports